import { openBlock as r, createElementBlock as o, createElementVNode as e, renderSlot as i } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
const d = {
  name: "DropdownTextDivider"
}, a = { class: "relative my-1.5 mx-3.5" }, c = { class: "relative flex justify-start" }, l = { class: "flex pr-2 ct-bg-1 text-sm ct-text-2" };
function p(s, t, f, m, _, x) {
  return r(), o("div", a, [
    t[0] || (t[0] = e("div", {
      class: "absolute inset-0 flex items-center",
      "aria-hidden": "true"
    }, [
      e("div", { class: "w-full border-t ct-border-2" })
    ], -1)),
    e("div", c, [
      e("span", l, [
        i(s.$slots, "default")
      ])
    ])
  ]);
}
const D = /* @__PURE__ */ n(d, [["render", p]]);
export {
  D
};
